/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
import { produce } from 'immer';
export function ParamMapping(def) {
    return function (_a) {
        var values = _a.values, update = _a.update, apply = _a.apply;
        return ({
            params: typeof def.params === 'function' ? def.params : function (ctx) { return def.params; },
            getTarget: def.target,
            getValues: values,
            update: function (s, ctx) {
                var t = def.target(ctx);
                return produce(t, function (t1) { return update(s, t1, ctx); });
            },
            apply: apply ? apply : function () { }
        });
    };
}
//# sourceMappingURL=param-mapping.js.map